import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/Layout";
import InviteUserDialog from "@/components/staff/InviteUserDialog";
import PendingInvites from "@/components/staff/PendingInvites";
import TeamMembersTable from "@/components/staff/TeamMembersTable";
import EditUserDialog from "@/components/staff/EditUserDialog";

export default function Staff() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [invites, setInvites] = useState([]);
  const [clients, setClients] = useState([]);
  const [editing, setEditing] = useState(null);

  const isAdmin = user.role === "Admin";

  const load = async () => {
    const [u, c] = await Promise.all([
      api.get("/users"),
      api.get("/clients"),
    ]);
    setUsers(u.data || []);
    setClients(c.data || []);
    if (isAdmin) {
      const i = await api.get("/invites");
      setInvites(i.data || []);
    }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-white" data-testid="staff-page">
      <PageHeader
        title="Staff"
        subtitle="Team & Roles"
        action={isAdmin && <InviteUserDialog onInvited={load} />}
      />

      <div className="px-4 sm:px-8 py-6 space-y-8">
        {isAdmin && <PendingInvites invites={invites} onChanged={load} />}
        <TeamMembersTable
          users={users}
          currentUserId={user.user_id}
          isAdmin={isAdmin}
          onEdit={setEditing}
          onChanged={load}
        />
      </div>

      <EditUserDialog
        editing={editing}
        setEditing={setEditing}
        clients={clients}
        onSaved={load}
      />
    </div>
  );
}
